import { useState } from "react";
import Sidebar from "../common/Sidebar";
import Header from "../common/Header";
import EmailCreateTemplateModal from "./EmailCreateTemplateModal";
import EmailMessageViewModal from "./EmailMessageViewModal";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import toast from "react-hot-toast";
import { deleteTemplate } from "../../../services/emailTemplateService";
import DeleteConfirmationModal from "../members/DeleteMemberModal";

const EmailTemplatesHandler = ({ template }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [selected, setSelected] = useState(null);
  const [editData, setEditData] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, item: null });

  const handleEditClick = (item) => {
    setEditData(item);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setEditData(null);
  };

  const handleDeleteClick = (item) => {
    setDeleteModal({ isOpen: true, item });
  };

  const handleDeleteConfirm = async () => {
    try {
      await deleteTemplate(deleteModal.item._id);
      toast.success("Template deleted!");
      window.location.reload();
    } catch (err) {
      toast.error(err.message || "Failed to delete");
    } finally {
      setDeleteModal({ isOpen: false, item: null });
    }
  };

  const closeDeleteModal = () => {
    setDeleteModal({ isOpen: false, item: null });
  };

  return (
    <>
      <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
        <div className="h-full">
          <div className="sticky top-0 h-screen text-white">
            <Sidebar />
          </div>
        </div>

        <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
          <PageWrapper>
            <div className="flex flex-col h-full">
              <div className="flex-1 p-4 overflow-y-auto">
                <Header
                  title="Templates"
                  desc="Here we can create and manage templates"
                />

                <section className="flex justify-end w-full mb-6 mt-4">
                  <div
                    onClick={() => setOpenModal(true)}
                    className="bg-[#4F22D8] cursor-pointer border border-[#0000003D] text-white px-4 py-2 text-sm font-semibold rounded-[10px] hover:opacity-90 transition"
                  >
                    + Create Template
                  </div>
                </section>

                <section className="bg-white rounded-xl overflow-hidden border border-[#D5D5D5] mt-10">
                  <div className="overflow-auto">
                    <table className="min-w-full text-sm font-medium text-black table-fixed border-l border-[#D5D5D5]">
                      <thead className="bg-[#4F22D8] text-white font-medium text-sm">
                        <tr>
                          <th className="px-4 py-3 text-left w-[80px] border-r border-[#D5D5D5]">
                            No
                          </th>
                          <th className="px-4 py-3 text-left w-[160px] border-r border-[#D5D5D5]">
                            Template Name
                          </th>
                          <th className="px-4 py-3 text-left w-[180px] border-r border-[#D5D5D5]">
                            Placeholders
                          </th>
                          <th className="px-4 py-3 text-center w-[500px] border-r border-[#D5D5D5]">
                            Sample Message
                          </th>
                          <th className="px-4 py-3 text-center w-[100px] border-r border-[#D5D5D5]"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {template.map((item, idx) => (
                          <tr
                            key={item._id}
                            className="text-sm text-black font-normal border-b border-[#B0B0B075] last:border-0"
                          >
                            <td className="px-4 py-3 border-l border-[#D5D5D5]">
                              {idx + 1}
                            </td>
                            <td className="px-4 py-3 text-center border-l border-[#D5D5D5]">
                              {item.templateName}
                            </td>
                            <td className="px-4 py-3 border-l text-center border-[#D5D5D5]">
                              {Array.isArray(item.placeholders) &&
                                item.placeholders.every(
                                  (p) => typeof p === "string"
                                ) &&
                                item.placeholders.map((placeholder, index) => (
                                  <div className="bg-" key={index}>
                                    {placeholder}
                                  </div>
                                ))}
                            </td>
                            <td className="px-4 py-3 border-l text-center border-[#D5D5D5]">
                              <div
                                className="prose-new max-w-none [&_h1]:text-xl [&_h1]:text-center [&_p]:text-center [&_img.editor-image]:mx-auto [&_img.editor-image]:rounded-lg [&_img.editor-image]:max-w-full [&_img.editor-image]:h-auto [&_button.editor-button]:bg-[#4F22D8] [&_button.editor-button]:text-white [&_button.editor-button]:px-4 [&_button.editor-button]:py-2 [&_button.editor-button]:rounded-md [&_button.editor-button]:text-sm [&_button.editor-button]:font-medium [&_button.editor-button]:mx-auto [&_button.editor-button]:block"
                                dangerouslySetInnerHTML={{
                                  __html: item.sampleMessage,
                                }}
                              />
                            </td>
                            <td className="px-4 py-3 border-l border-[#D5D5D5] text-center space-x-2">
                              <span
                                onClick={() => {
                                  setSelected(item);
                                  setOpenView(true);
                                }}
                                className="bg-[#E0E3FF] cursor-pointer text-[#1E30D4] px-3 py-1 rounded-[10px] font-semibold text-xs shadow-sm"
                              >
                                View
                              </span>

                              <span
                                onClick={() => handleEditClick(item)}
                                className="bg-[#FFF1C9] cursor-pointer text-[#B46900] px-3 py-1 rounded-[10px] font-semibold text-xs shadow-sm"
                              >
                                Edit
                              </span>

                              <span
                                onClick={() => handleDeleteClick(item)}
                                className="bg-[#FFDCDC] cursor-pointer text-[#D41E1E] px-3 py-1 rounded-[10px] font-semibold text-xs shadow-sm"
                              >
                                Delete
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
            </div>
          </PageWrapper>
        </div>
      </div>

      {openModal && (
        <EmailCreateTemplateModal
          onClose={closeModal}
          existingData={editData}
        />
      )}

      <EmailMessageViewModal
        isOpen={openView}
        onClose={() => setOpenView(false)}
        data={selected}
      />

      <DeleteConfirmationModal
        isOpen={deleteModal.isOpen}
        onRequestClose={closeDeleteModal}
        onDelete={handleDeleteConfirm}
        itemName={deleteModal.item?.templateName || "this template"}
        itemType="template"
      />
    </>
  );
};

export default EmailTemplatesHandler;
